<template>
    <div class="metric-pill d-flex align-items-center">
        <div class="pill-container d-flex castle-stone-0" :class="{ disabled: props.disabled }">
            <div
                v-for="pill in props.steps"
                class="pill d-flex align-items-center justify-content-center py-3"
                :class="[
                    { active: pill.label.slice(0, 3) === props.currentValue.slice(0, 3) },
                    pill.label.toLowerCase(),
                ]"
                :style="rangeStyle"
            >
                <p class="geist-font semi-bold pa-2">{{ pill.label }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'

const props = defineProps({
    steps: {
        type: Object,
        default: () => {},
    },
    currentValue: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const rangeStyle = computed(() => {
    const stepWidth = 100 / props.steps.length

    return {
        width: `${stepWidth}%`,
    }
})
</script>

<style scoped lang="scss">
@forward '@/styles/new_styles.scss';

.metric-pill {
    p {
        text-wrap: nowrap;
    }

    .pill-container {
        width: 100%;
        height: 34px;
        padding: 4px;
        border-radius: 15px;
        position: relative;

        .pill {
            text-align: center;
            border-radius: 16px;
            color: vars.$knightsCloak80;
            min-width: 60px;
            padding-top: 14px !important;

            &.active {
                background: white;
                box-shadow: 0px 1px 3px 0px rgba(37, 60, 85, 0.1);

                &.low {
                    color: vars.$error;
                }

                &.med {
                    color: vars.$warning;
                }

                &.high {
                    color: vars.$success;
                }

                &.not {
                    color: vars.$success;
                }
            }
        }
    }
}
</style>
